export enum DeflectedFetalPresentationGrade {
	FirstGrade = "0",
	SecondGrade = "1",
	ThirdGrade = "2",
}
